Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonReset = void 0;
exports.buttonReset = {
    ncss: {
        WebkitAppearance: 'button',
        textTransform: 'none',
        overflow: 'visible',
        fontFamily: 'text',
        fontSize: '100%',
        lineHeight: '1.15',
        m: 0,
        boxSizing: 'border-box',
        textDecoration: 'none',
        userSelect: 'none',
        cursor: 'pointer',
        '&:hover': {},
        '&:visited': {},
        '&:focus': {
            outlineColor: 'black',
            outlineOffset: 4,
            outlineWidth: 2,
            outlineStyle: 'dotted',
        },
        '&:active': {},
    },
};
//# sourceMappingURL=button-reset.js.map